import { CheckboxField, TextareaField } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { OrganizationalUnitOptionResource } from "../../types/organizationalUnit";
import { EventCategorySelectField } from "../../ui/EventCategorySelectField";
import { EventFormatSingleSelectField } from "../../ui/EventFormatSingleSelectField";
import { IndustrySelectField } from "../../ui/IndustrySelectField";
import { OrganizationalUnitSingleSelectField } from "../../ui/OrganizationalUnitSingleSelectField";
import { PreferenceMultiSelectField } from "../../ui/PreferenceSelectField";
import { RegionSelectField } from "../../ui/RegionSelectField";
import { TagMultiSelectField } from "../../ui/TagSelectField";
import { TargetGroupSelectField } from "../../ui/TargetGroupSelectField";
import { EventFormColumns } from "./EventFormColumns";
import { EventOrganizationalUnitMultiSelectField } from "./EventOrganizationalUnitMultiSelectField";
import { useEventTypeField } from "./useEventTypeField";

export const EventDetailsStepFormFields: FC = () => {
	const { t } = useTranslation();
	const eventType = useEventTypeField();
	const [{ value: organizationalUnits }, , { setValue }] =
		useField<OrganizationalUnitOptionResource[]>("organizationalUnits");
	const [{ value: primaryOrganizationalUnit }] = useField<OrganizationalUnitOptionResource | null>(
		"primaryOrganizationalUnit",
	);

	return (
		<EventFormColumns>
			{eventType?.eventGoalRequirement !== "prohibited" && (
				<TextareaField
					name="eventGoal"
					label={t("Event goal")}
					required={eventType?.eventGoalRequirement === "required"}
				/>
			)}
			{eventType?.formatRequirement !== "prohibited" && (
				<EventFormatSingleSelectField
					name="format"
					label={t("Format")}
					required={eventType?.formatRequirement === "required"}
				/>
			)}
			{eventType?.eventCategoryRequirement !== "prohibited" && (
				<EventCategorySelectField
					name="eventCategory"
					label={t("Category")}
					required={eventType?.eventCategoryRequirement === "required"}
				/>
			)}
			{eventType?.industryRequirement !== "prohibited" && (
				<IndustrySelectField
					name="industries"
					label={t("Industries")}
					required={eventType?.industryRequirement === "required"}
				/>
			)}
			{eventType?.targetGroupRequirement !== "prohibited" && (
				<TargetGroupSelectField
					name="targetGroup"
					label={t("Target group")}
					required={eventType?.targetGroupRequirement === "required"}
				/>
			)}
			{eventType?.regionRequirement !== "prohibited" && (
				<RegionSelectField name="region" label={t("Region")} required={eventType?.regionRequirement === "required"} />
			)}

			{eventType?.primaryOrganizationalUnitRequirement !== "prohibited" && (
				<OrganizationalUnitSingleSelectField
					name="primaryOrganizationalUnit"
					label={t("Primary organizational unit")}
					required={eventType?.primaryOrganizationalUnitRequirement === "required"}
					onChange={(e) => {
						if (eventType?.organizationalUnitRequirement !== "prohibited" && e.target.value) {
							void setValue(organizationalUnits.filter((unit) => unit.id !== e.target.value?.id));
						}
					}}
				/>
			)}
			{eventType?.organizationalUnitRequirement !== "prohibited" && (
				<EventOrganizationalUnitMultiSelectField
					name="organizationalUnits"
					label={t("Organizational units")}
					required={eventType?.organizationalUnitRequirement === "required"}
					primaryOrganizationalUnitId={primaryOrganizationalUnit?.id || null}
				/>
			)}
			{eventType?.tagRequirement !== "prohibited" && (
				<TagMultiSelectField name="tags" label={t("Tags")} required={eventType?.tagRequirement === "required"} />
			)}
			{eventType?.isHighlightRequirement !== "prohibited" && (
				<CheckboxField label={t("Highlight")} name="isHighlight" />
			)}
			{eventType?.preferenceRequirement !== "prohibited" && (
				<PreferenceMultiSelectField
					name="preferences"
					label={t("Preferences")}
					required={eventType?.preferenceRequirement === "required"}
				/>
			)}
		</EventFormColumns>
	);
};
